export default __webpack_public_path__ + "static/media/treat-yourself-1920w.9ff4063f.avif";